<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="menushow"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list
        dense
        style="font-size: 20px !imporatant"
      >
        <template v-for="item in menu">
          <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template #activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.href"
              link
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            :to="item.href"
            link
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      v-if="menushow"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />

      <img
        class="mr-3 hidden-sm-and-down"
        :src="menulogo"
        height="50"
      >

      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4 "
      >
        <span class="hidden-sm-and-down" />
      </v-toolbar-title>

      <v-spacer />
      <span class="hidden-sm-and-down">{{ loginInfo.uid }} 您好</span>

      <v-menu
        transition="slide-y-transition"
        bottom
      >
        <template #activator="{ on, attrs }">
          <v-btn
            dark
            text
            v-bind="attrs"
            v-on="on"
          >
            <v-badge
              color="green"
              :content="contentCount"
            >
              <span class="hidden-sm-and-down">
                <v-icon>fas fa-tachometer-alt</v-icon>
              </span>
            </v-badge>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, i) in contentList"
            :key="i"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.dat }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.title }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <router-link to="/Account">
        <v-btn outlined>
          修改密碼
        </v-btn>
      </router-link>

      <v-btn
        outlined
        @click="logout"
      >
        登出
      </v-btn>
    </v-app-bar>
    <v-content style="padding-bottom: 64px">
      <router-view />
    </v-content>
    <v-footer
      color="blue darken-3"
      app
      style="z-index: 999; justify-content: center"
    >
      <span class="white--text">
        <!-- © Copyright 2020 IGREEN Technology Corp. - All rights reserved. -->
        {{ loginUID.cust_slogan }}

        <!-- <br /><a style="color: white" href="www.igreent.com">www.igreent.com</a> -->
        <!-- Email : sales@igreent.com -->
      </span>
    </v-footer>
  </v-app>
</template>

<script>
import Cookies from "js-cookie";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib";
Vue.use(Vuetify);

export default {
  name: "App",
  data: () => ({
    menulogo: "",
    time: null,
    drawer: null,
    contentCount: 0,
    contentList: [],
  }),
  computed: {
    host() {
      // define @ \store\index.js
      return this.$store.state.host;
      
    },
    menu() {
      return this.$store.state.menu;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    menushow() {
      return this.$store.state.menushow;
    },
    loginUID() {
      return this.$store.state.loginUID;
    },
    exec_cust_gateway_000() {
      return this.$store.state.exec_cust_gateway_000;
    },
  },
  watch: {
    $route(to, from) {
      if (Cookies.get("Accountid") == null || Cookies.get("Accountid") == "") {
        this.$router.push("/Login");
      }
      if (this.$router.history.current.fullPath == "/") {
        this.$router.push("/Home");
      }

      if (to.name != "login") {
        this.$store.commit("setMenuShow", true);
      }
    },
    loginInfo() {
      // console.log("loginInfo",this.loginInfo)
      this.contentCount = 0;
      this.contentList = [];
      this.getData();
    },
  },
  unmounted() {
    if (this.time) {
      clearInterval(this.time);
    }
  },
  updated: function () {
    this.menulogo = this.host + "/" + this.loginUID.cust_logo;
  },
  created: function () {
    this.time = setInterval(() => {
      this.getData();
    }, 300 * 1000);

    //this.getData();
    if (this.loginInfo.Accountid == null || this.loginInfo.Accountid == 0) {
      this.$router.push("/Login");
      return;
    }
  },
  methods: {
    logout() {
      Cookies.remove("form");
      this.$store.commit("setMenuShow", false);
      Cookies.remove("url");
      this.$router.push("/Login");
    },
    getData() {
      let that = this;
      let nform = {
        cust_id: this.loginInfo.cust_id,
      };
      this.$store
        .dispatch("exec_cust_gateway_000", nform)
        .then((res) => {
          if (
            this.exec_cust_gateway_000 != null &&
            this.exec_cust_gateway_000.length > 0
          ) {
            // console.log(this.exec_cust_gateway_000);
            for (var i = 0; i < this.exec_cust_gateway_000.length; i++) {
              let item = this.exec_cust_gateway_000[i];
              let nform = {
                ip_adrs: item.ip_adrs,
              };

              that.$store
                .dispatch("exec_log_count_000", nform)
                .then((res) => {
                  //console.log("exec_log_count_000",res)
                  if (res != null && res.length > 0) {
                    that.contentCount =
                      Number(that.contentCount) + Number(res[0].err_num);
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            for (var i = 0; i < this.exec_cust_gateway_000.length; i++) {
              let item = this.exec_cust_gateway_000[i];
              let nform = {
                ip_adrs: item.ip_adrs,
              };

              that.$store
                .dispatch("exec_log_desc_000", nform)
                .then((resDesc) => {
                  if (resDesc != null && resDesc.length > 0) {
                    for (var j = 0; j < resDesc.length; j++) {
                      let item2 = resDesc[j];

                      let obj = {
                        dat: item2.dat,
                        title: item2.even,
                      };

                      if (j > 10) {
                        continue;
                      }

                      that.contentList.push(obj);
                    }
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style >
.v-list-item__title {
  font-size: 1rem !important;
  line-height: 1.3rem !important;
}

.analysismain .v-main__wrap {
  overflow-y: auto;
  height: calc(100% - 120px);
  padding-top: 64px;
}

.analysismain {
  padding: 10px !important;
  overflow-y: hidden;
  height: 100vh;
}
</style>